export default "__VITE_ASSET__DYiD2Y2s__"